export default (function () {
    var init = function () {
        const forms = document.querySelectorAll(".js-password-confirm");
        const formCount = forms.length; 

        if (formCount < 1) {
            return;
        }
        for (var i = 0; i < formCount; i++) {
            forms[i].addEventListener("submit", checkPasswordMatch);           
        }    
    };


    function checkPasswordMatch(e) {       
        const form = this;
        const passwordTextBoxes = form.querySelectorAll(".js-password");     

        if (passwordTextBoxes.length < 2) {
            console.log("Expected to find at least 2 password text boxes");
            return;
        }

        if (passwordTextBoxes[0].value != passwordTextBoxes[1].value) {
            const hint = form.querySelectorAll(".js-confirm-password-hint")[0];  
            hint.classList.add('js-show-validation');
            e.preventDefault();
            return false;         
        } 
    }   

    return {
        init: init
    };
})();